module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Guide Technique.94e38608b398570041ea9c08c5aec0ff.pdf";